module.exports = __webpack_public_path__ + "img/smile.5226ee58.svg";